import React, { useEffect, useState } from "react";
import { Package } from "lucide-react";
import { useAuth } from "../context/AuthContext";

const API = process.env.REACT_APP_BACKEND_URL;

const fmtDate = (iso) => {
  try {
    return new Date(iso).toLocaleDateString(undefined, { year: "numeric", month: "short", day: "numeric" });
  } catch {
    return "";
  }
};

export const OrderHistory = () => {
  const { token } = useAuth();
  const [orders, setOrders] = useState(null);

  useEffect(() => {
    let live = true;
    const load = async () => {
      try {
        const res = await fetch(`${API}/api/payments/my-orders`, {
          credentials: "include",
          headers: token ? { Authorization: `Bearer ${token}` } : {},
        });
        const data = await res.json();
        if (live && res.ok) setOrders(data.orders || []);
        else if (live) setOrders([]);
      } catch {
        if (live) setOrders([]);
      }
    };
    load();
    return () => { live = false; };
  }, [token]);

  return (
    <div className="profile-section" data-testid="order-history">
      <div className="profile-label"><Package size={14} /> Order history</div>
      {orders === null && <p className="profile-bio">Loading orders…</p>}
      {orders && orders.length === 0 && (
        <p className="profile-bio" data-testid="order-history-empty">No purchases yet.</p>
      )}
      {orders && orders.length > 0 && (
        <ul className="order-list">
          {orders.map((o) => (
            <li className="order-card" key={o.session_id} data-testid={`order-${o.session_id}`}>
              <div className="order-card-top">
                <span className="order-date">{fmtDate(o.created_at)}</span>
                <span className="order-total">${(o.amount / 100).toFixed(2)}</span>
              </div>
              <ul className="order-items">
                {o.items.map((it, idx) => (
                  <li key={idx}>{it.name} × {it.quantity}</li>
                ))}
              </ul>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};
